import { IntervalDate, When } from '@src/common/calendar';
import { FeaturedTariffPreviewMode, Scheduling, RescheduleScheduling } from '@src/core/buyerApiClient';
import { getSchedulingsTariffPreview } from '@src/domains/tariffs';
import { formatCents, infoCents } from '@src/common';

export type DayClassification = {
  isAvailable: boolean;
  isSoldOut: boolean;
  when: When;
  price: { currency: string; priceStr: string; fullPriceStr: string } | null;
  dateString: string;
};

type Props = {
  intervalDate: IntervalDate;
  availables: Scheduling[] | RescheduleScheduling[] | undefined;
  unavailables: Scheduling[] | RescheduleScheduling[] | undefined;
  tariffPreviewMode: FeaturedTariffPreviewMode | null | undefined;
};

export function classifyDay(props: Props): DayClassification {
  const { intervalDate, availables, unavailables, tariffPreviewMode } = props;

  const isAvailable = Boolean(availables?.length);
  const isSoldOut = Boolean(unavailables?.length) && !isAvailable;

  let price: DayClassification['price'] = null;
  if (isAvailable && tariffPreviewMode) {
    const priceCents = getSchedulingsTariffPreview(availables as Scheduling[], tariffPreviewMode);
    if (typeof priceCents === 'number') {
      const info = infoCents(priceCents);
      price = {
        currency: info.currency,
        priceStr: String(info.priceInt),
        fullPriceStr: formatCents(priceCents, false),
      };
    }
  }

  return {
    isAvailable,
    isSoldOut,
    when: intervalDate.when,
    price,
    dateString: intervalDate.dateString,
  };
}
